'use client';

import { createContext, useContext } from 'react';

import type { MarketingBrowserEvent } from '~/lib/marketing/tracking/config';

export interface MarketingTrackingValue {
  /**
   * Reports an anonymous event to every consented platform. `Contact` is the
   * demo scheduler unless a WhatsApp chat reference is given.
   */
  track(eventName: Exclude<MarketingBrowserEvent, 'PageView'>, whatsAppReference?: string): void;
  /** Reports a submitted lead in the browser; the server sends its CAPI twin. */
  trackLead(eventId: string): void;
  openConsentSettings(): void;
}

export const MarketingTrackingContext = createContext<MarketingTrackingValue | null>(null);

const NO_TRACKING: MarketingTrackingValue = {
  track: () => undefined,
  trackLead: () => undefined,
  openConsentSettings: () => undefined,
};

export function useMarketingTracking(): MarketingTrackingValue {
  return useContext(MarketingTrackingContext) ?? NO_TRACKING;
}
